module.exports = __webpack_public_path__ + "static/media/qr.3e2bdada.png";